module.exports = __webpack_public_path__ + "static/media/SuppliersPriceChangeIcon.103cceaa.svg";